import { getAccessToken } from "../awsAuth";

const API_BASE =
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_API ||
  (typeof window !== "undefined" &&
  window.location.hostname.includes("onrender.com")
    ? "https://cvanto-api.onrender.com"
    : "http://localhost:5000");

const HEARTBEAT_URL = `${API_BASE}/api/presence/heartbeat`;
const SESSION_ID_KEY = "cvanto:presenceSessionId";
const HEARTBEAT_INTERVAL_MS = 45000; // inside the requested 30-60s window

function getOrCreateSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_ID_KEY);
    if (!id) {
      id =
        (window.crypto?.randomUUID && window.crypto.randomUUID()) ||
        `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem(SESSION_ID_KEY, id);
    }
    return id;
  } catch {
    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
}

// Coarse mobile/desktop split via user-agent only — no fingerprinting, no
// screen/canvas/font probing. The presence row never stores the UA string
// itself, only this already-reduced two-value label.
function detectDeviceClass() {
  try {
    const ua = navigator.userAgent || "";
    return /Android|iPhone|iPad|iPod|Mobile|Windows Phone/i.test(ua) ? "mobile" : "desktop";
  } catch {
    return "desktop";
  }
}

async function sendHeartbeat() {
  const sessionId = getOrCreateSessionId();
  const deviceClass = detectDeviceClass();

  let token = null;
  try {
    token = await getAccessToken();
  } catch {
    token = null;
  }

  try {
    await fetch(HEARTBEAT_URL, {
      method: "POST",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ sessionId, platform: "web", deviceClass }),
    });
  } catch {
    // Best-effort — a missed heartbeat just means this session looks
    // offline a little sooner than it should; never worth surfacing.
  }
}

let started = false;

// Sends a heartbeat every ~45s while the tab is visible, and immediately
// once whenever it becomes visible again — paused entirely while hidden so
// a backgrounded tab never inflates the "online now" count. Call once from
// App's top-level mount effect.
export function startPresenceHeartbeat() {
  if (typeof document === "undefined" || started) return;
  started = true;

  const tick = () => {
    if (document.visibilityState === "visible") {
      sendHeartbeat();
    }
  };

  tick();
  setInterval(tick, HEARTBEAT_INTERVAL_MS);

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") tick();
  });
}
